import { Component, OnInit } from '@angular/core';
import { SubheaderHandlerService } from '../../nav/subheader-handler.service';

@Component({
    selector: 'nalco-application-downtime',
    templateUrl: './application-downtime.component.html',
    styleUrls: ['./application-downtime.component.scss'],
    standalone: false
})
export class ApplicationDowntimeComponent implements OnInit {

  subheaderData = {
    leftSection: {
      type: '',
      data: '',
      className: 'col-lg-6'
    },
    middleSection: {
      type: '',
      data: [],
      className: ''
    },
    rightSection: {
      type: '',
      data: [],
      className: ''
    }
  };

  constructor(  private subHeaderService: SubheaderHandlerService) {
    this.subheaderData.leftSection.data = '';
    this.subHeaderService.updateLeftSection(this.subheaderData.leftSection);
    this.subHeaderService.updateMiddleSection(this.subheaderData.middleSection);
    this.subHeaderService.updateRightSection(this.subheaderData.rightSection);
   }

  ngOnInit() {
  }

}
